import Utils from './utils.js';

/**
 * Class Param Visibility
 */
export default class Param {

	/**
	 * Helper function to return an object of the URL params. { 'paramName: 'paramValue' }
	 * @returns {{}}
	 */
	getUrlSearchParamsObject() {
		const ret = {};
		for (const [ key, value ] of new URLSearchParams( location.search ).entries() ) {
			ret[ key ] = value;
		}
		return ret;
	}

	/**
	 * Helper function to return an object of the params saved in the
	 * cookie for the current page.
	 *
	 * @param paramsData
	 * @returns {{}}
	 */
	getCookieParamsObject( paramsData) {
		const ret = {};
		const paramsArray = paramsData[ script_vars.page_id.toString() ];
		if ( paramsArray ) {
			paramsArray.forEach( param => {
				ret[ param.name ] = param.value;
			} );
		}
		return ret;
	}



	/**
	 * Handle param visibility conditions.
	 * Remove "hideClass" from element if it passed the param validation.
	 */
	handleParamVisibility( element, elementData, elementIsAllHide, showAllHideElement ) {

			// If item has already been shown
			if ( ! element.classList.contains( Utils.hideClass ) ) {
				return;
			}

			const paramSettings = elementData.params_settings.params || [];

			const urlParams = this.getUrlSearchParamsObject();
			let paramsDataCookie = JSON.parse( Utils.getCookie( 'visibility_params_data' ) || '{}' );
			const cookieParams = this.getCookieParamsObject( paramsDataCookie );
			const allRequestParams = { ...cookieParams, ...urlParams }; // current url params + params from cookie

			let paramsToSave = Utils.compareRequestToSettings(
				element,
				paramSettings,
				this.getParams( allRequestParams ),
				elementIsAllHide,
				showAllHideElement
			);

			if ( paramsToSave.length > 0 && 'yes' === elementData.params_settings.save_cookies ) {
				paramsDataCookie[ script_vars.page_id.toString() ] = paramsToSave;
				Utils.setCookie( 'visibility_params_data', JSON.stringify( paramsDataCookie ), elementData.params_settings.save_cookies_time );
			}

	}

	getParams( params ) {
		const paramsArary = [];
		for ( const paramName in params ) {
			paramsArary.push( {
				name: paramName,
				value: params[paramName]
			} );
		}
		return paramsArary;
	}

}
